import { CodigoAcessoComponent } from './../codigo-acesso/codigo-acesso.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlteracaoSenhaComponent } from '../alteracao-senha/alteracao-senha.component';
import { RecuperarSenhaComponent } from '../recuperar-senha.component';



const recuperarSenhaRoutes = [
  { path: 'esqueceuSenha', component: RecuperarSenhaComponent },
  { path: 'codigoAcesso', component: CodigoAcessoComponent },
  { path: 'alterarSenha', component: AlteracaoSenhaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(recuperarSenhaRoutes)],
  exports: [RouterModule]
})
export class RecuperarSenhaRoutingModule {}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/recuperar-senha/route/recuperar-senha.routing.module.ts